module.exports = __webpack_public_path__ + "static/team-events-83e1b02330d395f349b354ae2758fbd8.png";